const billIssue = () => import('@/pages/review/bill-issue/bill-issue')
const exdateChange = () => import('@/pages/review/exdate-change/exdate-change')
const pay = () => import('@/pages/review/pay/pay')
const financing = () => import('@/pages/review/financing/financing')
const cashing = () => import('@/pages/review/cashing/cashing')
const guarantee = () => import('@/pages/review/guarantee/guarantee')
export default [
    {
        path: 'review/bill-issue',
        name: 'review/bill-issue',
        component: billIssue
    },
    {
        path: 'review/exdate-change',
        name: 'review/exdate-change',
        component: exdateChange
    },
    {
        path: 'review/pay',
        name: 'review/pay',
        component: pay
    },
    {
        path: 'review/financing',
        name: 'review/financing',
        component: financing
    },
    {
        path: 'review/cashing',
        name: 'review/cashing',
        component: cashing
    },
    {
        path: 'review/guarantee',
        name: 'review/guarantee',
        component: guarantee
    },
]



// WEBPACK FOOTER //
// ./src/router/review.js